module.exports = __webpack_public_path__ + "files/8990c7331e127535efac57d80ba3d6b6.png";